import { Default, Detail,  List, Create } from "./views";

const Module = {
    name: "areas",
    defaultRoutePath: "/commercials/area",
    menuItemScope: "operations",
    menuItemName: "area",

    routes: [
        {
            path: "/commercials/area",
            protected: true,
            children: [
                {
                    index: true,
                    path: "",
                    Component: Default,
                },
                {
                    path: "list",
                    Component: List,
                },
            ],
        },
    ],
    drawerRoutes: [
        {
            path: "list",
            Component: List,
        },
        {
            path: "detail",
            Component: Detail,
        },
        
        {
            path: "create",
            Component: Create,
        },
    ],

}

export default Module;
